// import React, { useEffect, useState } from "react";
// import "./loader.css";

// const Loader = () => {
//  const [isVisible, setIsVisible] = useState(false);
//    useEffect(() => {
//       const timer = setTimeout(() => {
//         setIsVisible(true);
//       }, 1000);
//       return () => clearTimeout(timer);
//     }, []);

//     if (!isVisible) return null;
//   return (
//     <div className="container">
//       <div className="three col">
//         <div className="loader" id="loader-3"></div>
//       </div>
//     </div>
//   );
// };

// export default Loader;


import React, { useState, useEffect } from "react";
import { useRive } from "@rive-app/react-canvas";
import "./loader.css";

const Loader = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [loadError, setLoadError] = useState(false);

  // Construct the correct URL based on the environment
  // For app.squarebridge.org, we need to ensure the path is absolute
  const loaderSrc = `${process.env.REACT_APP_PUBLIC_URL}?key=loader.riv`;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const { rive, RiveComponent } = useRive({
    src: loaderSrc,
    animations: "loading_animation",
    autoplay: true,
    onLoad: () => {
      console.log("Rive animation loaded successfully");
      setLoadError(false);
    },
    onLoadError: (error) => {
      console.error("Rive animation load error:", error);
      console.error("Attempted to load from:", loaderSrc);
      setLoadError(true);
    }
  });

  useEffect(() => {
    if (rive) {
      try {
        rive.play();
      } catch (error) {
        console.error("Error playing Rive animation:", error);
        setLoadError(true);
      }
    }
  }, [rive]);

  if (!isVisible) return null;

  return (
    <>
      {loadError ? (
        <div className="container">
          <div className="three col">
            <div className="loader" id="loader-3"></div>
          </div>
        </div>
      ) : (
        <div className="loader-container">
          <div className="rive-loader">
            {RiveComponent && <RiveComponent />}
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;